import _ from 'lodash';
import fp from 'lodash/fp';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { withRouter, withClient } from '@deerplusofficial/pos-hoc';
import { getResult, createCancelToken } from '@deerplusofficial/pos-helper';

export default () => Component =>
  fp.compose(
    withClient(),
    withRouter()
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryTax');

      state = {};

      async componentDidMount() {
        const {
          channelId,
          client: { onError, POSApi },
        } = this.props;

        try {
          const {
            tax: { name, category, rate },
          } = getResult(
            await POSApi.get('/tax', {
              params: { channel_id: channelId },
              cancelToken: createCancelToken(this.cancelQuery),
            })
          );
          this.setState({
            tax: {
              name,
              type: ['included', 'excluded'][category],
              rate: rate * 0.01,
            },
          });
        } catch (e) {
          onError(e);
        }
      }

      componentWillUnmount() {
        !_.isUndefined(this.cancelQuery) && this.cancelQuery();
      }

      render() {
        return <Component tax={this.state.tax} {...this.props} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryTax.js